'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _breakpoints = require('../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _editorial = require('../../../organisms/editorial');

var _editorial2 = _interopRequireDefault(_editorial);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _themeManager = require('../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();
var ORGANISM_NAME = 'enhanced-editorial';

var renderCta = function renderCta(cta, color) {
  if (cta && cta.text) {
    var targetValue = cta.target || '_self';
    return _react2.default.createElement(
      _button2.default,
      {
        id: cta.id,
        href: cta.href,
        color: color || cta.color || null,
        className: ORGANISM_NAME + '__cta',
        fpti: 'EnhcdEdtrl-' + (cta.type || 'cta') + '-' + (cta.fpti || cta.text),
        target: targetValue
      },
      cta.text
    );
  }
  return null;
};

var renderLegalText = function renderLegalText(legalText) {
  if (legalText && legalText.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__notes legal-notes' },
      htmlToReactParser.parse(legalText.text)
    );
  }
  return null;
};

var EnhancedEditorial = function (_Editorial) {
  _inherits(EnhancedEditorial, _Editorial);

  function EnhancedEditorial(props) {
    _classCallCheck(this, EnhancedEditorial);

    var _this = _possibleConstructorReturn(this, (EnhancedEditorial.__proto__ || Object.getPrototypeOf(EnhancedEditorial)).call(this, props));

    _this.handleScroll = _this.handleScroll.bind(_this);
    // adding references in case this component is extended
    _this.renderCta = renderCta;
    _this.renderEnhancedContentSection = _this.renderEnhancedContentSection.bind(_this);
    _this.renderLegalText = renderLegalText;
    _this.handleResize = _this.handleResize.bind(_this);
    _this.state = {
      showImages: false,
      isMobile: false
    };
    return _this;
  }

  _createClass(EnhancedEditorial, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableEnchancedImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'renderEnhancedContentSection',
    value: function renderEnhancedContentSection(content, isMobile) {
      var headline = content.headline,
          paragraph = content.paragraph,
          hatchText = content.hatchText,
          primaryCta = content.primaryCta,
          secondaryCta = content.secondaryCta;

      return _react2.default.createElement(
        'div',
        {
          className: 'col-xs-12 col-md-6\n          ' + ORGANISM_NAME + '__container ' + ORGANISM_NAME + '__text\n          text-xs-center text-md-left'
        },
        this.renderHeadline(headline),
        this.renderParagraph(paragraph),
        renderCta(primaryCta),
        isMobile ? renderCta(secondaryCta, 'outline-blue') : renderCta(secondaryCta),
        this.renderHatchText(hatchText)
      );
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      var newWindowWidth = Math.min(this.organismRef.ownerDocument.defaultView.innerWidth, this.organismRef.ownerDocument.documentElement.clientWidth, this.organismRef.ownerDocument.body.clientWidth);
      if (newWindowWidth >= _breakpoints2.default.medium) {
        if (this.state.isMobile) {
          this.setState({
            isMobile: false
          });
        }
      } else if (!this.state.isMobile) {
        this.setState({
          isMobile: true
        });
      }
    }
  }, {
    key: 'enableEnchancedImages',
    value: function enableEnchancedImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'renderImage',
    value: function renderImage(image) {
      if (this.state.showImages && image && image.src) {
        return _react2.default.createElement('img', { className: ORGANISM_NAME + '__image', src: image.src, alt: image.alt || null });
      }
      return null;
    }
  }, {
    key: 'renderImageSection',
    value: function renderImageSection(deviceImage) {
      return _react2.default.createElement(
        'div',
        {
          className: 'col-md-6\n          hidden-sm-down text-xs-center\n          ' + ORGANISM_NAME + '__container ' + ORGANISM_NAME + '__device-image'
        },
        this.renderImage(deviceImage)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var theme = this.props.config.theme || 'theme-background-image-dark';
      var newProps = (0, _themeManager2.default)(this.props, theme);
      var content = newProps.content;
      var _props = this.props,
          config = _props.config,
          className = _props.className;
      var id = config.id,
          textPosition = config.textPosition,
          backgroundImage = config.backgroundImage,
          backgroundPosition = config.backgroundPosition;
      var isMobile = this.state.isMobile;


      var backgroundImageStyle = {
        background: '#fff',
        color: '#000'
      };

      var deviceImage = content.deviceImage,
          legalText = content.legalText;

      var enchdedtrClasses = (0, _classnames2.default)('' + ORGANISM_NAME, theme, className);

      if (isMobile === false) {
        backgroundImageStyle = this.state.showImages && backgroundImage && backgroundImage.url ? {
          backgroundImage: 'url(' + backgroundImage.url + ')',
          backgroundPosition: '' + (backgroundPosition || 'center')
        } : null;
      }

      var bgPortableImageStyle = backgroundImage && backgroundImage.portableURL ? {
        backgroundImage: 'url(' + backgroundImage.portableURL + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;

      var bgMobileImageStyle = backgroundImage && backgroundImage.mobileURL ? {
        backgroundImage: 'url(' + backgroundImage.mobileURL + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;
      return _react2.default.createElement(
        'section',
        {
          id: id,
          className: enchdedtrClasses,
          'data-building-block': 'organism',
          style: backgroundImageStyle,
          ref: function ref(c) {
            _this2.organismRef = c;
          }
        },
        backgroundImage.portableURL ? _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__portable ' + ORGANISM_NAME + '__bg', style: bgPortableImageStyle },
          '\xA0'
        ) : null,
        backgroundImage.mobileURL ? _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__mobile  ' + ORGANISM_NAME + '__bg', style: bgMobileImageStyle },
          '\xA0'
        ) : null,
        _react2.default.createElement(
          'div',
          { className: 'container' },
          textPosition === 'right' ? _react2.default.createElement(
            'div',
            { className: 'row' },
            this.renderImageSection(deviceImage),
            this.renderEnhancedContentSection(content, isMobile)
          ) : _react2.default.createElement(
            'div',
            { className: 'row' },
            this.renderEnhancedContentSection(content, isMobile),
            this.renderImageSection(deviceImage)
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-md-12 ' + ORGANISM_NAME + '__legal-text  text-xs-center floatLeft' },
              this.renderLegalText(legalText)
            )
          )
        )
      );
    }
  }]);

  return EnhancedEditorial;
}(_editorial2.default);

exports.default = EnhancedEditorial;


EnhancedEditorial.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light', 'theme-background-image-dark', 'theme-background-image-light']).isRequired,
    textPosition: _propTypes2.default.oneOf(['left', 'right']),
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      mobileURL: _propTypes2.default.string,
      portableURL: _propTypes2.default.string
    }),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right'])
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    deviceImage: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired,
      alt: _propTypes2.default.string
    }),
    primaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    secondaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    legalText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

EnhancedEditorial.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-image-dark',
    textPosition: 'left',
    backgroundImage: {
      url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/de/de/passport/home/01_Home_Hero.jpg',
      mobileURL: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/de/de/passport/home/01_Home_Hero.jpg',
      portableURL: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/de/de/passport/home/01_Home_Hero.jpg'
    },
    backgroundPosition: 'center'
  },
  content: {
    headline: {
      text: '36 characters maximum or 2 lines.'
    },
    paragraph: {
      text: '120 characters maximum per line for paragraphs, ' + 'using text blocks equal in height to optional device images.'
    },
    deviceImage: {
      src: 'https://www.paypalobjects.com/webstatic/en_US/mktg/wright/mobile-apps/narr_sendmoney_enus_1x.png',
      alt: 'Text should describe the "device image" example.'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    secondaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    hatchText: {
      text: '34 characters maximum per line'
    },
    legalText: {
      text: '64 characters maximum per line'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/enhanced-editorial/jsx/EnhancedEditorial.js
// module id = 1084
// module chunks = 4